import { authentication as Authentication } from "./authentication";
import * as Errors from "./errors";
import {
  clearMocks,
  disableFakes,
  enableFakes,
  getDefaultMockSignedRequestResponse,
  setMockSignedRequestResponse,
  setSignedRequestResponseStatus,
} from "./testing";
import * as Types from "./types";

const Testing = {
  enableFakes,
  disableFakes,
  clearMocks,
  setSignedRequestResponseStatus,
  setMockSignedRequestResponse,
  getDefaultMockSignedRequestResponse,
};

export { Authentication, Errors, Testing, Types };
